// Observe the document so HTMX body replacements and attribute changes work too.
export function loadControllers(application, automatic, overrides = {}, root = document.documentElement) {
    const loaders = { ...automatic, ...overrides };
    const pending = new Map();

    function scan(element) {
        if (element.nodeType !== Node.ELEMENT_NODE) return;
        for (const node of [element, ...element.querySelectorAll('[data-controller]')]) {
            for (const name of (node.dataset.controller || '').split(/\s+/)) {
                if (!Object.prototype.hasOwnProperty.call(loaders, name) || pending.has(name)) continue;
                const task = Promise.resolve()
                    .then(() => loaders[name]())
                    .then(controller => application.register(name, controller))
                    .catch(error => {
                        pending.delete(name); // Allow a later scan to retry a failed download.
                        console.error('Unable to load controller:', name, error);
                    });
                pending.set(name, task);
            }
        }
    }

    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            if (mutation.type === 'attributes') scan(mutation.target);
            else mutation.addedNodes.forEach(scan);
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-controller'],
    });
    scan(root);
    return observer;
}
